// extracted by mini-css-extract-plugin
export var cardHeader = "_gn-1";
export var contentCard = "_gn-0";
export var headerActions = "_gn-3";
export var reorderHandle = "_gn-5";
export var titleArea = "_gn-2";
export var titleAreaWithHandle = "_gn-4";